// import React, { useState } from "react";
// import axios from "axios";
// import { Button } from "@mui/material";
// // import "./FingerprintCapture.css";

// const FingerprintCapture = ({ onSuccess, onError }) => {
//   const [fingerloading, setFingerLoading] = useState(false);
//   const [step, setStep] = useState("");
//   const [status, setStatus] = useState(""); // success | error | ""

//   const captureFingerprint = async () => {
//     try {
//       setFingerLoading(true);
//       setStatus("");
//       setStep("Discovering RD Service...");

//       await axios.get("http://localhost:5001/api/discover");

//       setStep("Fetching Device Info...");
//       await axios.get("http://localhost:5001/api/device-info");

//       setStep("Please place your finger on scanner...");

//       const pidXml = `<?xml version="1.0"?>
// <PidOptions ver="1.0">
//   <Opts fCount="1" fType="0" format="0" pidVer="2.0" timeout="10000" env="P"/>
// </PidOptions>`;

//       const res = await axios.post(
//         "http://localhost:5001/api/capture",
//         pidXml,
//         { headers: { "Content-Type": "text/xml" } }
//       );

//       const xml = res.data;

//       if (xml.includes('errCode="0"')) {
//         setStatus("success");
//         setStep("Authentication Successful ✅");
//         onSuccess && onSuccess(xml);
//       } else {
//         throw new Error("Capture failed");
//       }

//     } catch (err) {
//       setStatus("error");
//       setStep("Fingerprint not captured ❌");
//       onError && onError();
//     } finally {
//       setTimeout(() => {
//         setFingerLoading(false);
//         setStep("");
//         setStatus("");
//       }, 2000);
//     }
//   };

//   return (
//     <>
//       {/* 🔘 Capture Button */}
//       <Button
//         fullWidth
//         variant="outlined"
//         onClick={captureFingerprint}
//         sx={{
//           borderColor: "#ff7a00",
//           color: "#ff7a00",
//           padding: "8px",
//         }}
//       >
//         Capture Fingerprint
//       </Button>

//       {/* 🧠 EXISTING POPUP (REUSED) */}
//       {fingerloading && (
//         <div className="fp-backdrop">
//           <div className="fp-modal">
//             <div className="finger-scan">
//               <span></span>
//             </div>

//             <h3 className="fp-title">Biometric Authentication</h3>
//             <p className="fp-step">{step}</p>

//             <p className="fp-hint">
//               Please place your finger properly on the scanner
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default FingerprintCapture;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const FingerprintCapture = ({ onSuccess, onError,startCapture }) => {
  const [fingerloading, setFingerLoading] = useState(false);
  const [step, setStep] = useState("");
  const [status, setStatus] = useState(""); 
  // "", "success", "error"

  useEffect(() => {
    if (startCapture) {
      captureFingerprint();
    }
    // eslint-disable-next-line
  }, [startCapture])
  const captureFingerprint = async () => {
    // ✅ Validation: already captured
    if (status === "success") return;

    try {
      setFingerLoading(true);
      setStatus("");
      setStep("Discovering RD Service...");

      await axios.get("http://localhost:5001/api/discover", { timeout: 5000 });

      setStep("Fetching Device Info...");
      await axios.get("http://localhost:5001/api/device-info", { timeout: 5000 });

      setStep("Please place your finger on scanner...");

      const pidXml = `<?xml version="1.0"?>
<PidOptions ver="1.0">
  <Opts fCount="1" fType="0" format="0" pidVer="2.0" timeout="10000" env="P"
   wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw="
  />
</PidOptions>`;

      const res = await axios.post(
        "http://localhost:5001/api/capture",
        pidXml,
        { headers: { "Content-Type": "text/xml" }, timeout: 15000 }
      );

      const xml = res.data;

      if (!xml || !xml.includes('errCode="0"')) {
        throw new Error("Capture failed");
      }

      // ✅ SUCCESS
      setStatus("success");
      setStep("Authentication Successful ✅");
      onSuccess && onSuccess(xml);

    } catch (err) {
      // ❌ ERROR
      setStatus("error");
      setStep("Fingerprint not captured ❌");
      onError && onError();
    } finally {
      setTimeout(() => {
        setFingerLoading(false);
        setStep("");
      }, 2000);
    }
  };

  // 🔘 Button Content
  const renderButtonContent = () => {
    if (fingerloading) {
      return <CircularProgress size={20} color="inherit" />;
    }

    if (status === "success") {
      return (
        <>
          <CheckCircleIcon sx={{ mr: 1 }} />
          Fingerprint Captured
        </>
      );
    }

    if (status === "error") {
      return (
        <>
          <ErrorIcon sx={{ mr: 1 }} />
          Capture Failed
        </>
      );
    }

    return "Capture Fingerprint";
  };


  useEffect(() => {
  if (status === "error") {
    const timer = setTimeout(() => {
      setStatus("");
    }, 5000);

    return () => clearTimeout(timer);
  }
}, [status]);

  return (
    <>
      {/* 🔘 Capture Button with status */}
      <Button
        fullWidth
        variant="outlined"
        onClick={captureFingerprint}
        disabled={fingerloading || status === "success"}
        sx={{
          padding: "8px",
          borderColor:
            status === "success"
              ? "#2e7d32"
              : status === "error"
              ? "#d32f2f"
              : "#ff7a00",
          color:
            status === "success"
              ? "#2e7d32"
              : status === "error"
              ? "#d32f2f"
              : "#ff7a00",
          fontWeight: 600,
        }}
      >
        {renderButtonContent()}
      </Button>

      {/* 🧠 EXISTING POPUP */}
      {fingerloading && (
        <div className="fp-backdrop">
          <div className="fp-modal">
            <div className="finger-scan">
              <span></span>
            </div>

            <h3 className="fp-title">Biometric Authentication</h3>
            <p className="fp-step">{step}</p>

            <p className="fp-hint">
              Please place your finger properly on the scanner
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default FingerprintCapture;
